import PropTypes from "prop-types";

/**
 * Toast/Notification Shape
 * Shape for toast notification data
 *
 * @typedef {Object} Toast
 * @property {string} title - Toast title text (required)
 * @property {string} [message] - Toast message/description text
 * @property {('success'|'error'|'warning'|'info')} [appearance] - Visual variant
 * @property {number} [duration] - Auto-dismiss duration in milliseconds
 */
export const toastShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  appearance: PropTypes.oneOf(["success", "error", "warning", "info"]),
  duration: PropTypes.number,
});
